export default "__VITE_ASSET__DvLAMT8R__"